module.exports = __webpack_public_path__ + "assets/img/icon7.43f7ef57.png";